import { useState } from 'react';
import { VcfCapability } from '@/hooks/useWorkstreams';

export function CapabilityModal({
  capability,
  onSave,
  onDelete,
  onClose,
}: {
  capability: VcfCapability | null;
  onSave: (data: { code: string; name: string; description?: string; cls?: 'CORE' | 'RECOMMENDED' | 'OPTIONAL'; defaultIncluded?: boolean; isActive?: boolean }) => void;
  onDelete?: () => void;
  onClose: () => void;
}) {
  const [code, setCode] = useState(capability?.code || '');
  const [name, setName] = useState(capability?.name || '');
  const [description, setDescription] = useState(capability?.description || '');
  const [cls, setCls] = useState<'CORE' | 'RECOMMENDED' | 'OPTIONAL'>(capability?.cls || 'OPTIONAL');
  const [defaultIncluded, setDefaultIncluded] = useState(capability?.defaultIncluded ?? false);
  const [isActive, setIsActive] = useState(capability?.isActive ?? true);

  return (
    <div className="dialog-overlay">
      <div className="dialog max-w-lg">
        <div className="dialog-header">
          <h2 className="dialog-title">{capability ? 'Edit Capability' : 'Add Capability'}</h2>
        </div>
        <div className="dialog-body space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="label">Code *</label>
              <input type="text" value={code} onChange={(e) => setCode(e.target.value)} className="input mt-1 w-full" placeholder="e.g., CAP-01" required />
            </div>
            <div>
              <label className="label">Classification</label>
              <select value={cls} onChange={(e) => setCls(e.target.value as 'CORE' | 'RECOMMENDED' | 'OPTIONAL')} className="input mt-1 w-full">
                <option value="CORE">Core</option>
                <option value="RECOMMENDED">Recommended</option>
                <option value="OPTIONAL">Optional</option>
              </select>
            </div>
          </div>
          <div>
            <label className="label">Name *</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input mt-1 w-full" placeholder="e.g., VCF Architecture Review" required />
          </div>
          <div>
            <label className="label">Description</label>
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="input mt-1 w-full" rows={2} placeholder="Optional description" />
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <input type="checkbox" id="cap-default" checked={defaultIncluded} onChange={(e) => setDefaultIncluded(e.target.checked)} />
              <label htmlFor="cap-default" className="text-sm">Included by default</label>
            </div>
            {capability && (
              <div className="flex items-center gap-2">
                <input type="checkbox" id="cap-active" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
                <label htmlFor="cap-active" className="text-sm">Active</label>
              </div>
            )}
          </div>
        </div>
        <div className="dialog-footer">
          {onDelete && (
            <button type="button" onClick={onDelete} className="btn-secondary text-red-600 hover:bg-red-50 mr-auto">
              Delete
            </button>
          )}
          <button type="button" onClick={onClose} className="btn-secondary">Cancel</button>
          <button onClick={() => onSave({ code, name, description: description || undefined, cls, defaultIncluded, isActive })} className="btn-primary" disabled={!code.trim() || !name.trim()}>
            {capability ? 'Save' : 'Create'}
          </button>
        </div>
      </div>
    </div>
  );
}
